import * as React from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { ChangeEvent } from 'react';

interface IExpansionProps {
  headline: string;
  bodyText: string;
  index: number;
  expanded: string | false;
  handleChange: (
    panel: string
  ) => ((event: ChangeEvent<{}>, expanded: boolean) => void) | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '80%',
      flexShrink: 0,
    },
  })
);

const Expansion: React.FC<IExpansionProps> = ({
  headline,
  bodyText,
  index,
  expanded,
  handleChange,
}): JSX.Element => {
  const classes = useStyles({});

  return (
    <Accordion
      expanded={expanded === `panel${index}`}
      onChange={handleChange(`panel${index}`)}
      key={index}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${index}bh-content`}
        id={`panel${index}bh-header`}
      >
        <Typography
          className={classes.heading}
          dangerouslySetInnerHTML={{ __html: headline }}
        />
      </AccordionSummary>
      <AccordionDetails>
        <Typography dangerouslySetInnerHTML={{ __html: bodyText }} />
      </AccordionDetails>
    </Accordion>
  );
};

export default Expansion;
